import PropTypes from 'prop-types';
import React from 'react'
import Helmet from 'react-helmet'
import { filter } from 'underscore'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { serverUrl } from "../config/site";

let metadata = {

	titleTemplate: " - Five to Nine Club",

	articles() {
		return {
			title: "Discover our articles and workshops"
		}
	},

	article(article) {
		return {
			title: article.title,
			meta: [
		        {"name": "description", "content": article.excerpt},
		        {"property": "og:title", "content": article.title},
		        {"property": "og:description", "content": article.excerpt},
		        {"property": "og:type", "content": "article"},
		        {"property": "og:article:published_time", "content": article.date},
		        {"property": "og:article:author", "content": article.user.first + ' ' + article.user.last},
		        {"property": "og:image", "content": article.images.full},
		        {"property": "og:url", "content": serverUrl + article.link}
		    ]
		}
	},

	workshop(workshop) {
		return {
			title: workshop.title,
			meta: [
	            {"name": "description", "content": workshop.excerpt},
	            {"property": "og:title", "content": workshop.title},
	            {"property": "og:description", "content": workshop.excerpt},
	            {"property": "og:type", "content": "website"},
	            {"property": "og:image", "content": workshop.images.full},
	            {"property": "og:url", "content": serverUrl + workshop.link}
	        ]
	    }
	},

	camp(camp) {
		return {
			title: camp.title,
			meta: [
	            {"name": "description", "content": camp.description},
	            {"property": "og:title", "content": camp.title},
	            {"property": "og:description", "content": camp.description},
	            {"property": "og:type", "content": "website"},
	            {"property": "og:image", "content": camp.cover_banner},
	            {"property": "og:url", "content": serverUrl + camp.link}
	        ]
	    }
	},

	dashboard() {
		return {
			title: 'Community',
			meta: [
	            {"name": "description", "content": 'Create a camp for your industry, interest or area. Join a camp and share ideas with your peers, friends and business mentors. Have a discussion, get inspired.'},
	            {"property": "og:title", "content": 'Community'},
	            {"property": "og:description", "content": 'Create a camp for your industry, interest or area. Join a camp and share ideas with your peers, friends and business mentors. Have a discussion, get inspired.'},
	            {"property": "og:type", "content": "website"},
	            {"property": "og:url", "content": serverUrl}
        	]
        }
	},

	interest(interest) {
		return {
			title: 'Filter: ' + interest.tag,
			meta: [
                {"name": "description", "content": 'Check out our content for ' + interest.title},
                {"property": "og:title", "content": 'Filter: ' + interest.tag},
                {"property": "og:description", "content": 'Check out our content for ' + interest.title},
                {"property": "og:type", "content": "website"},
                {"property": "og:url", "content": serverUrl + interest.link}
            ]
		}
	},

	profile(user) {
		return {
			title: user.first + ' ' + user.last,
			meta: [
                {"name": "description", "content": 'View the Five to Nine Club profile for ' + user.first + ' ' + user.last + '. Join Five to Nine Club to connect with entrepreneurs and small business owners. Learn from others and grow your business with Five to Nine Club.'},
                {"property": "og:title", "content": user.first + ' ' + user.last},
                {"property": "og:description", "content": 'View the Five to Nine Club profile for ' + user.first + ' ' + user.last + '. Join Five to Nine Club to connect with entrepreneurs and small business owners. Learn from others and grow your business with Five to Nine Club.'},
                {"property": "og:type", "content": "website"},
                {"property": "og:url", "content": serverUrl + user.link}
            ]
		}
	},

    signup() {
        return {
            title: "Sign up to our newsletter"
        }
    },

	addNotifications(title, newNumber) {

		let match = title.match(/\((\d+)\)\s/),
			currentNumber = !!match && match.length > 1 ? +match[1] : 0;

		if( newNumber == currentNumber || !newNumber ) return title

		let pre = newNumber > 0 ? '(' + newNumber + ') ' : '',
			titleToEdit = title.replace(/(\(\d+\)\s)/, "").replace(this.titleTemplate,""),
			newTitle = pre + titleToEdit;

		return newTitle

	},

	notFound() {
		return {
			title: "Page Not Found"
		}
	}

}

class MetaData extends React.Component {
    static propTypes = {
		notifications: PropTypes.array,
		vars: PropTypes.object,
		page: PropTypes.string
	};

    getInitialProps = () => {
		return {
			notifications: [],
			vars: {}
		}
	};

    getUnread = (notifications) => {
		var notifications = !!notifications && notifications.length > 0 ? notifications.slice(0) : [],
			unread = filter(notifications, {seen: false}).length;
		return unread;
	};

    state = {
        unread: this.getUnread(this.props.notifications),
        lastPage: ''
    };

    shouldComponentUpdate(nextProps, nextState) {
		if( nextProps.page === 'init' && 'vars' in this.props ) return false;
		if( this.state.unread === this.getUnread(nextProps.notifications) ) return false;
		return true;
	}

    componentDidUpdate(prevProps) {

		if( !('notifications' in this.props) ) return

		var unread = this.getUnread(this.props.notifications)

		if( this.state.unread == unread ) return;

		this.setState({
			unread: unread
		})

	}

    render() {

		if( this.props.page === 'init' ) return <Helmet 
			defaultTitle={metadata.addNotifications("Learning and community for aspiring small business owners, startups and entrepreneurs", this.state.unread)}
			titleTemplate={"%s" + metadata.titleTemplate}
		/>

		let vars = 'vars' in this.props ? this.props.vars : {},
			data = metadata[this.props.page](vars)

		return(
            <Helmet
				title={ metadata.addNotifications(data.title, this.state.unread) }
				meta={'meta' in data ? data.meta : []}
			/>
		);

	}
}

const mapStateToProps = state => ({
    notifications: state.notifications.stored,
});

export default connect(
    mapStateToProps
)( MetaData );



// WEBPACK FOOTER //
// ./src/js/components/MetaData.js